import React from "react";

export default function Footer()
{
 return(<>
    <footer className="text-center text-lg-start"  >
        <div className="text-center p-3" style={{backgroundColor:"#000"}}>
          Made With Love &#10084;
          <p className="d-inline text-dark" >  By Shoham Dey Sarkar</p>
        </div>
    </footer>
 </>);
}